import { useQuery } from '@tanstack/react-query';
import { ICustomerFullProfile } from '../../interfaces/customer';
import { ClientService } from '../../services/client';
import { IBaseUseQueryProps } from '../../interfaces/baseUseQueryProps';

interface IProps extends IBaseUseQueryProps<ICustomerFullProfile> {
  id: number;
}

export const CLIENT_ENTITY_QUERY_KEY = 'get-client-entity';

export const useGetClientEntity = ({ id, ...props }: IProps) => useQuery({
  queryKey: [CLIENT_ENTITY_QUERY_KEY, id],
  queryFn: () => ClientService.getOneById(id),
  refetchOnWindowFocus: true,
  retry: 0,
  ...props,
});